import { render } from "./CertificateComponent.vue?vue&type=template&id=3b61849e"
import script from "./CertificateComponent.vue?vue&type=script&lang=js"
export * from "./CertificateComponent.vue?vue&type=script&lang=js"

import "./CertificateComponent.vue?vue&type=style&index=0&id=3b61849e&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.12_webpack@5.96.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__